import React from 'react'
import './FaceBook.css'
import { FaFacebookF } from "react-icons/fa";

const FaceBook = () => {
  return (
    <div>
         <div class="face_book">
    <a href="https://www.facebook.com/" target="_blank">
        <i class="fab fa-facebook-square"></i><span>FaceBook<br/><small></small></span>
    </a>
</div>
    </div>
  )
}

export default FaceBook
